"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = URL;
exports.isURL = isURL;
function URL() {}

var regexp = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

// https://stackoverflow.com/questions/8667070/javascript-regular-expression-to-validate-url
function isURL(value) {
	return regexp.test(value);
}
//# sourceMappingURL=URL.js.map


//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/commonjs/types/URL.js
// module id = 471
// module chunks = 1